document.addEventListener("DOMContentLoaded", function () {
    var currentPath = window.location.pathname;
    document
    .querySelectorAll(".custom-list-menu-all a")
    .forEach(function (link) {
        var linkPath = link.getAttribute("href");
        if (linkPath && linkPath !== "#" && currentPath === linkPath) {
        link.classList.add("active");
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    let items = document
        .querySelector(".header__inline-menu")
        .querySelectorAll("details");
    let stickyHeader = document.querySelector(".shopify-section-header-sticky");
    items.forEach((item) => {
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            if (stickyHeader) {
                stickyHeader.classList.add("scrolled-past-header");
            }
            item.querySelector("ul").addEventListener("mouseleave", () => {
                item.removeAttribute("open");
                if (stickyHeader) {
                    stickyHeader.classList.remove("scrolled-past-header");
                }
            });
            item.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
                if (stickyHeader) {
                    stickyHeader.classList.remove("scrolled-past-header");
                }
            });
        });
    });
});
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/') {
    setTimeout(function() {
      var locationPopup = document.getElementById('location-popup');
      if(locationPopup) {
        locationPopup.classList.add('active');
      }
    }, 3000);
  }
});

function reinitializeSlick() {
    let $slider = $('.wrap_upsell');
    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick'); 
    }
    $slider.slick({
        arrows: false,          // no arrows
        dots: false,            // no dots
        infinite: false,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        responsive: [
        {
            breakpoint: 480, // below 480px
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1
            }
        }
    ]
    });

    // Update progress bar on slide change
    $slider.on('afterChange', function(event, slick, currentSlide){
        const totalSlides = slick.slideCount - slick.options.slidesToShow + 1; // max scrollable slides
        const progressPercent = ((currentSlide + 1) / totalSlides) * 100;
        $('.progress-bar .progress').css('width', progressPercent + '%');
    });

    // Set initial progress bar for the first slide
    const slickObj = $slider.slick('getSlick');
    const totalSlides = slickObj.slideCount - slickObj.options.slidesToShow + 1;
    const initialProgress = ((0 + 1) / totalSlides) * 100;
    $('.progress-bar .progress').css('width', initialProgress + '%');
}

reinitializeSlick();

function addToCartVariant(id,vId) {
    let varId = $(`#product_variant__${id}`).val();
    let inputQty = $(`#qty-val-${id}`).val();
    if(!varId){
        varId = vId;
    } 
    if(!inputQty){
        inputQty = 1;
    }
    let formData = {
        id: varId,
        quantity: inputQty,
    };
    $.ajax({
        url: '/cart/add',
        type: 'POST',
        data: formData,
        success: function (response) {
            $.ajax({
                url: '/?section_id=cart-drawer',
                type: 'GET',
                dataType: 'html',
                success: function (carthtml) {
                    $('cart-drawer').html($(carthtml).find('cart-drawer').html());
                    reinitializeSlick();
                },
            });
        },
    });
}